import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/Home";
import WhoWeAre from "../components/WhoWeAre";
import OurStaff from "../components/OurStaff";
import OurServices from "../components/OurServices";
import OurValues from "../components/OurValues";
import JobDashboard from "../components/JobDashboard";
import JobDetails from "../components/JobDetails";
import ContactUs from "../components/ContactView";
import SecureUpload from "../components/SecureUploadView";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/who-we-are",
    name: "who-we-are",
    component: WhoWeAre,
  },
  {
    path: "/our-staff",
    name: "our-staff",
    component: OurStaff,
  },
  {
    path: "/our-services",
    name: "our-services",
    component: OurServices,
  },
  {
    path: "/our-values",
    name: "our-values",
    component: OurValues,
  },
  {
    path: "/job-dashboard",
    name: "job-dashboard",
    component: JobDashboard,
  },
  {
    path: "/job-details/:id",
    name: "job-details",
    component: JobDetails,
    props: true,
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: ContactUs,
  },
  {
    path: "/secure-upload",
    name: "secure-upload",
    component: SecureUpload,
  },
];

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 };
  }
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
});
export default router;
